import script from "./GradeManagementPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeManagementPage.vue?vue&type=script&setup=true&lang=js"

import "./GradeManagementPage.vue?vue&type=style&index=0&id=29564b7e&scoped=true&lang=css"
import "./GradeManagementPage.vue?vue&type=style&index=1&id=29564b7e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29564b7e"]])

export default __exports__